class NormalizedPoint {
  constructor(pointX, pointY, containerWidth, containerHeight) {
    this.x = pointX / containerWidth;
    this.y = pointY / containerHeight;
    this.isTop = this.y < 0.5;
    this.isBottom = !this.isTop;
    this.isLeft = this.x < 0.5;
    this.isRight = !this.isLeft;
  }
}
/**
 * Given a DOMRect, determines which quadrant of the container each corner of the rect is in.
 * @param rect - The rect to obtain the points for
 * @param container - The container the rect points are relative to (defaults to window)
 */

function pointsForRect(
  rect,
  container = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
) {
  const { top, right, bottom, left } = rect;
  const { width, height } = container;
  return {
    topLeft: new NormalizedPoint(left, top, width, height),
    topRight: new NormalizedPoint(right, top, width, height),
    bottomLeft: new NormalizedPoint(left, bottom, width, height),
    bottomRight: new NormalizedPoint(right, bottom, width, height),
  };
}

export { pointsForRect };
